import React, { ReactNode } from 'react'
import { connect } from 'react-redux'
import { Grid, Grow, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import MikeNavWarnBanner from '@mike/mike-shared-frontend/mike-nav-warn-banner/MikeNavWarnBanner'
import appLogoImg from './appLogo.png'

import { ReactComponent as Logo } from '@mike/mike-shared-frontend/media/icons/LandingPage'

import './landingpage.css'
import splash from './splashscreen.jpg'

const StyledBanner = styled('div')({
  position: 'absolute',
  top: 0,
  zIndex: 11,
  width: '100%'
})

const StyledWrapper = styled('div')({
  padding: '50px 40px 25px 40px'
})

const StyledHeader = styled(Typography)({
  display: 'inline-block',
  verticalAlign: 'top',
  margin: '0 0 35px 15px'
})

type Props = {
  children?: ReactNode
}

const LandingLayout = ({ children }: Props) => {
  const background = {
    backgroundImage: `url(${splash})`
  }

  return (
    <>
      <StyledBanner>
        <MikeNavWarnBanner showAlways={false} />
      </StyledBanner>
      <div className="LandingPage" style={background}>
        <div className="LandingPage-logo">
          <Logo />
        </div>

        <div className="LandingPage-content">
          <Grow in={true}>
            <StyledWrapper>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={0}
              >
                <Grid item={true} xs={12}>
                  <img src={appLogoImg} height="56" alt="logo" />
                  <StyledHeader
                    color="primary"
                    gutterBottom={true}
                    variant="h1"
                  >
                    Cloud Admin
                  </StyledHeader>
                </Grid>

                {children}
              </Grid>
            </StyledWrapper>
          </Grow>
        </div>
      </div>
    </>
  )
}

export default connect()(LandingLayout)
